module.exports = __webpack_public_path__ + "static/media/paint-roller.553d7133.svg";